/* Corporate / B2B landing page behaviour (PRO-1843).
   Markup: sections/corporate-landing-v2.liquid */
(function () {
  var LEAD_ENDPOINT = 'https://57rcqblb3f.execute-api.us-west-2.amazonaws.com/prod/thanhgiong/api/form-submissions';
  var MIN_FILL_MS = 2000;
  // Google Ads "Corporate Lead Form Submission" conversion (PRO-2091).
  var ADS_CONVERSION_SEND_TO = 'AW-956258057/zF0DCNykyoUdEImu_ccD';

  function scrollToId(targetId) {
    var target = document.getElementById(targetId);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------------------------------------------------------------- nav + CTAs */

  function initScrollTriggers(root) {
    var contactId = root.getAttribute('data-contact-target');

    root.querySelectorAll('[data-b2b-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        scrollToId(button.getAttribute('data-b2b-scroll'));
      });
    });

    // Every CTA on the page routes to the lead form.
    root.querySelectorAll('[data-b2b-cta]').forEach(function (button) {
      button.addEventListener('click', function () {
        scrollToId(contactId);
        var firstField = root.querySelector('[data-b2b-field="name"]');
        if (firstField) {
          window.setTimeout(function () {
            firstField.focus({ preventScroll: true });
          }, 500);
        }
      });
    });
  }

  /* ------------------------------------------------------------------ carousel */

  function initCarousel(root) {
    var carousel = root.querySelector('[data-b2b-carousel]');
    if (!carousel) return;

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-b2b-slide]'));
    if (slides.length < 2) return;

    var counter = carousel.querySelector('[data-b2b-count]');
    var prev = carousel.querySelector('[data-b2b-prev]');
    var next = carousel.querySelector('[data-b2b-next]');
    var index = 0;

    function render() {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      if (counter) counter.textContent = index + 1 + ' / ' + slides.length;
    }

    function go(step) {
      index = (index + step + slides.length) % slides.length;
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    render();
  }

  /* ----------------------------------------------------------------------- FAQ */

  function initFaq(root) {
    root.querySelectorAll('[data-b2b-faq-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.classList.toggle('b2b-hidden', isOpen);
      });
    });
  }

  /* ---------------------------------------------------------------- lead form */

  function parsePhoneRobust(phone) {
    if (!window.libphonenumber) return null;
    var attempts = [
      function () { return window.libphonenumber.parsePhoneNumber(phone); },
      function () { return window.libphonenumber.parsePhoneNumber(phone, 'US'); },
    ];
    for (var i = 0; i < attempts.length; i++) {
      try {
        var parsed = attempts[i]();
        if (parsed && parsed.isValid()) return parsed;
      } catch (e) {
        /* try the next strategy */
      }
    }
    return null;
  }

  function initForm(root) {
    var form = root.querySelector('[data-b2b-form]');
    if (!form) return;

    var formView = form.querySelector('[data-b2b-form-view]');
    var successView = form.querySelector('[data-b2b-success-view]');
    var successMessage = form.querySelector('[data-b2b-success-message]');
    var errorBox = form.querySelector('[data-b2b-error]');
    var submitBtn = form.querySelector('[data-b2b-submit]');
    var honeypot = form.querySelector('[data-b2b-honeypot]');
    var successTemplate = successMessage ? successMessage.textContent : '';

    // Time-on-form spam guard. The old modal started this clock on open; the form
    // is inline now, so it starts at page load and is re-based on the first real
    // interaction, which is what makes the check measure actual fill time.
    // It deliberately never blocks on "no interaction seen" — if the events do not
    // arrive (autofill, unusual input method) the page-load baseline still lets a
    // genuine submit through rather than locking the form permanently.
    var engagedAt = Date.now();
    var engaged = false;
    ['focusin', 'input'].forEach(function (type) {
      form.addEventListener(type, function () {
        if (engaged) return;
        engaged = true;
        engagedAt = Date.now();
      });
    });

    function field(name) {
      return form.querySelector('[data-b2b-field="' + name + '"]');
    }

    function value(name) {
      var el = field(name);
      return el ? el.value.trim() : '';
    }

    function setFieldError(name, hasError) {
      var el = field(name);
      if (!el) return;
      var wrapper = el.closest('.b2b-field');
      if (!wrapper) return;

      wrapper.classList.toggle('is-invalid', hasError);
      var hint = wrapper.querySelector('.b2b-field__error');

      if (hasError && !hint) {
        hint = document.createElement('span');
        hint.className = 'b2b-field__error';
        hint.textContent = 'Required';
        wrapper.appendChild(hint);
        el.addEventListener('input', function () { setFieldError(name, false); }, { once: true });
      } else if (!hasError && hint) {
        hint.remove();
      }
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.classList.remove('b2b-hidden');
    }

    function hideError() {
      if (errorBox) errorBox.classList.add('b2b-hidden');
    }

    // gtag is loaded site-wide by GTM (Elevar app embed). Tracking must never
    // break the form, so a missing gtag or a gtag error is swallowed.
    function trackLeadConversion() {
      if (typeof window.gtag !== 'function') return;
      try {
        window.gtag('event', 'conversion', { send_to: ADS_CONVERSION_SEND_TO });
      } catch (e) {
        console.warn('[b2b] Conversion tracking failed.', e);
      }
    }

    async function submit(event) {
      if (event) event.preventDefault();

      // Spam guards: hidden honeypot + minimum time-on-form.
      if (honeypot && honeypot.value) {
        console.warn('[b2b] Honeypot filled — submission blocked.');
        return;
      }
      var elapsed = Date.now() - engagedAt;
      if (elapsed < MIN_FILL_MS) {
        console.warn('[b2b] Form submitted too fast (' + elapsed + 'ms) — submission blocked.');
        return;
      }

      hideError();

      var required = ['name', 'email', 'company', 'phone', 'referral', 'notes'];
      var missing = false;
      required.forEach(function (name) {
        var isEmpty = !value(name);
        setFieldError(name, isEmpty);
        if (isEmpty) missing = true;
      });
      if (missing) return;

      var name = value('name');
      var parsedPhone = parsePhoneRobust(value('phone'));

      var payload = {
        full_name: name,
        work_email: value('email'),
        company: value('company'),
        phone: parsedPhone ? parsedPhone.number : value('phone'),
        volume: value('volume').replace(/–/g, '-').replace(/,/g, ''),
        primary_use_case: value('usecase'),
        custom_build_description: value('notes'),
        referral_source: value('referral'),
        source: 'corp_form_v2',
        submitted_at: new Date().toISOString(),
      };

      var originalLabel = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      try {
        var res = await fetch(LEAD_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          var body = await res.json().catch(function () { return {}; });
          throw new Error(body.message || 'Error ' + res.status);
        }

        if (successMessage && successTemplate) {
          successMessage.textContent = 'Thanks, ' + name + '. ' + successTemplate;
        }
        formView.classList.add('b2b-hidden');
        successView.classList.remove('b2b-hidden');
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        trackLeadConversion();
      } catch (err) {
        showError(err.message || 'Something went wrong. Please try again.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      }
    }

    // Listening on the form covers both the submit button and Enter in a field.
    form.addEventListener('submit', submit);
  }

  /* ---------------------------------------------------------------------- boot */

  function initSection(root) {
    if (!root || root.dataset.b2bReady === 'true') return;
    root.dataset.b2bReady = 'true';

    initScrollTriggers(root);
    initCarousel(root);
    initFaq(root);
    initForm(root);
  }

  function initAll() {
    document.querySelectorAll('.b2b-page[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor re-render support.
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('.b2b-page[data-section-id]'));
  });
})();
